import { EnumBase } from 'hay-core-react';
class HomologacaoIntegracaoCampoConsultaEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.homologacaointegracao.campoconsulta.cpf',
                'main.homologacaointegracao.campoconsulta.telefone',
                'main.homologacaointegracao.campoconsulta.email',
            ],
            'main.homologacaointegracao.campoconsulta.cpf'
        );
    }
}

const instance = new HomologacaoIntegracaoCampoConsultaEnum();
export default instance;
